import { Component } from 'react';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import PropTypes from 'prop-types';
import { DEPOSIT_META } from 'scripts/metadata/account';
import { user as userPropType } from 'scripts/constants/PropTypes';
import { userSelector } from 'scripts/redux/selectors/user';
import { sendPayidDepositEmail } from 'scripts/redux/actions/bpay';


const mapStateToProps = (state) => ({
  ...userSelector(state),
});

@connect(mapStateToProps, {
  sendPayidDepositEmail,
})
export default class PayidDetails extends Component {
  static propTypes = {
    user: userPropType.isRequired,
    sendPayidDepositEmail: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { user, sendPayidDepositEmail } = this.props;
    window.scrollTo(0, 0);

    if (user && user.email) {
      sendPayidDepositEmail();
    }
  }

  render() {
    const { user } = this.props;
    const payid = 'deposits@brickx.com';
    const ref = user.email ? user.email : 'Your email address';

    return (
      <div className="deposit-success deposit-success-payid">
        <DocumentMeta {...DEPOSIT_META} />
        <div className="container">
          <div className="deposit-success-body">
            <div className="deposit-success__title deposit-success-payid__title"><strong>Your PayID details</strong></div>
            <div className="deposit-success__sub-title deposit-success-payid__sub-title">Now, log in to your internet banking or contact your bank to make the deposit using PayID</div>
            <div className="deposit-success-payid-info">
              <div className="deposit-success-payid-block-wrap">
                <div className="deposit-success-payid-block">
                  <div className="deposit-success-payid-block__details">
                    <div className="deposit-success-payid-block__logo">
                      <img className="deposit-success-payid-logo__image" src="/static/images/deposit/payid_logo.png" />
                    </div>
                    <div className="deposit-success-payid-block__info">
                      <div className="deposit-success-payid-block__info-text">Use your online banking to complete this transaction.</div>
                      <br/>
                      <div className="deposit-success-payid-block__info-text"><strong>PayID&#174;:</strong> <span className="payid-code">{payid}</span></div>
                      <div className="deposit-success-payid-block__info-text"><strong>Reference:</strong> <span className="payid-reference">{ref}</span></div>
                      <br/>
                      <div className="deposit-success-payid-block__info-text-small">PayID is a registered trademark of NPP Australia Limited.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="deposit-success-payid-other-details">
                <div className="deposit-success-payid-estimated-arrival">
                  <img className="deposit-success-payid-estimated-arrival__image" src="/static/images/icons/icn_calendar.png"/>
                  ESTIMATED ARRIVAL: <span className="deposit-success-payid-estimated-arrival__date text-orange">INSTANT</span>
                </div>
                <ul className="deposit-success-payid-good-points">
                  <li>Your unique PayID Details</li>
                  <li>Simple and free - no fees</li>
                  <li>No registrations needed</li>
                  <li>Funds delivered instantly</li>
                </ul>
                Note: First-time PayID deposits to BrickX may take up to 24 hours due to bank security checks. Future deposits will be instant.
              </div>
            </div>
            <div className="deposit-success-payid-bank-info">
              <div className="deposit-success-payid-bank-info__navigate-title deposit-success__title">Navigate to your bank</div>
              <div className="deposit-success-payid-bank-info__navigate-sub-title deposit-success__sub-title">Don’t see your bank? No worries, we accept PayID from any PayID participating financial institution - simply log in to your internet or telephone banking.</div>
              <div className="deposit-success-payid-bank-info__banks">
                <a href="https://www.my.commbank.com.au/netbank/Logon/Logon.aspx" target="_blank"><img className="deposit-success-payid-bank-info__bank-logo" src="/static/images/bank-icons/commbank.gif"/></a>
                <a href="https://banking.westpac.com.au/wbc/banking/handler?TAM_OP=login&segment=personal&logout=false" target="_blank"><img className="deposit-success-payid-bank-info__bank-logo" src="/static/images/bank-icons/westpac.gif"/></a>
                <a href="https://www.anz.com/INETBANK/bankmain.asp?_ga=2.252931849.1224788643.1497488531-1390836690.1497488531" target="_blank"><img className="deposit-success-payid-bank-info__bank-logo" src="/static/images/bank-icons/ANZ.gif"/></a>
                <a href="https://ib.nab.com.au/nabib/index.jsp" target="_blank"><img className="deposit-success-payid-bank-info__bank-logo" src="/static/images/bank-icons/NAB.gif"/></a>
                <a href="https://ibanking.stgeorge.com.au/ibank/loginPage.action" target="_blank"><img className="deposit-success-payid-bank-info__bank-logo" src="/static/images/bank-icons/stgeorge.gif"/></a>
                <a href="https://www.ingdirect.com.au/securebanking/" target="_blank"><img className="deposit-success-payid-bank-info__bank-logo" src="/static/images/bank-icons/ING.gif"/></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
